export interface AlivenessTrait {
  id: string;
  title: string;
  body: string;
  trigger: string;
}

export const alivenessTraits: AlivenessTrait[] = [
  {
    id: 'aandacht',
    title: 'Aandacht',
    body: 'De kern en de binnenste deeltjes leunen naar waar je bent. De buitenste schil volgt trager, zodat het voelt als kijken, niet als schuiven.',
    trigger: 'Cursor of vinger in de buurt',
  },
  {
    id: 'rondkijken',
    title: 'Rondkijken',
    body: 'Zonder input kijkt Anna af en toe rond met korte, snelle blikken. Tijdens nadenken dwaalt haar blik omhoog en opzij; tijdens luisteren blijft ze bij jou.',
    trigger: 'Na 2,5 s zonder beweging',
  },
  {
    id: 'knipperen',
    title: 'Knipperen',
    body: 'Elke 3 tot 7 seconden dimt de kern heel even en trekt de binnenzwerm samen. Soms twee keer kort achter elkaar.',
    trigger: 'Wakkere toestanden',
  },
  {
    id: 'ademen',
    title: 'Onregelmatig ademen',
    body: 'Het ademritme varieert licht, en in rust volgt af en toe een diepe zucht. ’s Avonds ademt Anna trager en kleurt ze warmer.',
    trigger: 'Rust · tijd van de dag',
  },
  {
    id: 'reactie',
    title: 'Lichamelijke reactie',
    body: 'Bij elke toestandswissel veert ze kort mee: opveren bij luisteren, inkeren bij nadenken, terugdeinzen bij zorg.',
    trigger: 'Toestandswissel',
  },
  {
    id: 'stem',
    title: 'Stem op woordniveau',
    body: 'Tijdens spreken pulseert de kern op de woordgrenzen van de echte spraak, niet op een vaste lus.',
    trigger: 'Spreekt, met geluid aan',
  },
  {
    id: 'aanraking',
    title: 'Aanraking',
    body: 'Tik op de kern en Anna veert op, glinstert even en stuurt één zachte golf uit.',
    trigger: 'Tik op de kern',
  },
];
